<template>
	<el-form ref="medicationForm" :model="medication" :rules="rules" label-width="100px" v-loading="loading">

		<h1 v-if="isNew">Ajout d'un nouveau médicament</h1>
		<h1 v-else>Modification du médicament : {{ medication.label }}</h1>
			
		<el-form-item label="Libellé" prop="label">
			<el-input v-model="medication.label" placeholder="Libellé" maxlength="100"></el-input>
		</el-form-item>

		<el-form-item label="Modes" prop="giveModes">
			<el-select v-model="selectedGiveModeIds" multiple placeholder="Aucun" class="select" no-data-text="Aucun mode d'administration">
				<el-option v-for="giveMode in giveModes" :key="giveMode.id" :label="giveMode.label" :value="giveMode.id" :disabled="!giveMode.valid"></el-option>
			</el-select>
		</el-form-item>

		<el-form-item label="Prescription" prop="prescription">
			<el-switch v-model="medication.prescription"></el-switch>
		</el-form-item>

		<el-form-item label="Actif" prop="valid">
			<el-switch v-model="medication.valid"></el-switch>
		</el-form-item>

		<div style="text-align: center;">
			<el-button icon="fas fa-times" @click="back"> Annuler</el-button>
			<el-button icon="fas fa-save" @click="submit" type="primary"> Enregistrer</el-button>
		</div>
	</el-form>
</template>

<script>
import MedicationService from '@/services/medication.service'
import GiveModeService from '@/services/giveMode.service'
import StringUtils from '@/utils/string.utils'

export default {
	name: 'medication',
	data: function () {
		return {
			loading: true,
			medication: {},
			giveModes: [],
			selectedGiveModeIds: [],
        	rules: {
				label: [ { required: true, message: 'Veuillez saisir le libellé du médicament', trigger: 'blur' } ],
				giveModes: [ { required: true, message: 'Veuillez sélectionner un mode d\'administration', trigger: 'blur' } ]
			}
		}
	},
	computed: {
		isNew: function() {
			return this.$route.params.itemId == 'new'
		}
	},
	methods: {
		submit() {

			// Copie les modes sélectionnés dans l'objet medicament
			if (this.selectedGiveModeIds && this.selectedGiveModeIds.length > 0) {
				this.medication.giveModes = this.selectedGiveModeIds.map(id => this.giveModes.find((e) => e.id == id))
			} else {
				this.medication.giveModes = []
			}

			// Valide le formulaire
			this.$refs['medicationForm'].validate((valid) => {
				if (valid) {

					// Affiche le loader
					this.loading = true

					// Enregistrement du médicament
					MedicationService.saveMedication(this.medication).then(() => {

						// Retour liste
						this.$router.push('/medications')
					})

				} else {
					return false;
				}
			});
		},
		back() {
			// Retour liste
			this.$router.push('/medications')
		}
	},
	mounted: function() {

		// Charge et tri la liste des modes d'administrations
		GiveModeService.getGiveModes().then((giveModes) => {
			this.giveModes = giveModes
			this.giveModes.sort((a, b) => StringUtils.compareIgnoreCase(a.valid ? '0':'1' + a.label, b.valid ? '0':'1' + b.label));
		})

		// Récupère le médicament si ce n'est pas un ajout
		if(!this.isNew) {
			MedicationService.getMedication(this.$route.params.itemId).then((medication) => {

				this.medication = medication
				if (medication.giveModes && medication.giveModes.length > 0) {
					this.selectedGiveModeIds = medication.giveModes.map(g => g.id);
				} else {
					this.selectedGiveModeIds = []
				}
				this.loading = false
			})
		} else {
			this.medication = { prescription: true, valid: true }
			this.selectedGiveModeIds = []
			this.loading = false
		}
	}
}
</script>

<style scoped>

	h1 {
		margin-bottom: 30px;
		margin-left: 30px;
	}

	.select {
		width: 100%;
	}

</style>